export const advisors = [
  { 
    name: "Ricky", 
    role: "Sales Advisor", 
    phone: "60122887272", 
    img: "/SA/RICKY.jpg" 
  },
  { 
    name: "Chey", 
    role: "Sales Advisor", 
    phone: "60162479160", 
    img: "/SA/CHEY.jpg" 
  },
  { 
    name: "Alan", 
    role: "Sales Advisor", 
    phone: "60129207777", 
    img: "/SA/ALAN.jpg" 
  },
  { 
    name: "Izaac", 
    role: "Sales Advisor", 
    phone: "60102268337", 
    img: "/SA/IZAAC.jpg" 
  },
  { 
    name: "Ridzuan", 
    role: "Sales Advisor", 
    phone: "60173879888", 
    img: "/SA/RIDZUAN.jpg" 
  },
  { 
    name: "Vincent", 
    role: "Sales Advisor", 
    phone: "60166188226", 
    img: "/SA/VINCENT.jpg" 
  },
  { 
    name: "Zaid", 
    role: "Sales Advisor", 
    phone: "60172004413", 
    img: "/SA/ZAID.jpg" 
  },
  { 
    name: "Chong", 
    role: "Sales Advisor", 
    phone: "60193212292", 
    img: "/SA/CHONG.jpg" 
  },
  { 
    name: "Annie", 
    role: "Sales Advisor", 
    phone: "60122837803", 
    img: "/SA/ANNIE.jpg" 
  },
  { 
    name: "Jackson", 
    role: "Sales Advisor", 
    phone: "60163090799", 
    img: "/SA/JACKSON.jpg" 
  },
  { 
    name: "Jeffery", 
    role: "Sales Advisor", 
    phone: "60176397587", 
    img: "/SA/JEFFERY.jpg" 
  },
  { 
    name: "Conner", 
    role: "Sales Advisor", 
    phone: "60162456113", 
    img: "/SA/CONNER.jpg" 
  },
  { 
    name: "CY", 
    role: "Sales Advisor", 
    phone: "60189189138", 
    img: "/SA/CY.jpeg" 
  },
  { 
    name: "BK", 
    role: "Sales Advisor", 
    phone: "60176207519", 
    img: "/SA/BK.jpg" 
  },
  { 
    name: "Jia Jie", 
    role: "Sales Advisor", 
    phone: "601157725572", 
    img: "/SA/JIAJIE.jpg" 
  },
  { 
    name: "Kumar", 
    role: "Sales Advisor", 
    phone: "60146011223", 
    img: "/SA/KUMAR.jpg" 
  },
  { 
    name: "Jonathan", 
    role: "Sales Advisor", 
    phone: "60182283180", 
    img: "/SA/JONATHAN.jpg" 
  }
];
